import Vue from `vue`
import Hero from `./Hero.vue`

new Vue({
    el: 'app1',
    components: { Hero }
});